"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNameFix = exports.getPassThroughProps = exports.I18nCommonMixin = exports.commonPropTypes = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _I18n = _interopRequireDefault(require("I18n"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var commonPropTypes = {
  message: _propTypes.default.string.isRequired,
  options: _propTypes.default.object,
  useGap: _propTypes.default.bool
};
exports.commonPropTypes = commonPropTypes;
var I18nCommonMixin = {
  getDefaultProps: function getDefaultProps() {
    return {
      options: {},
      useGap: false
    };
  },
  _getValue: function _getValue() {
    var unescapeOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _this$props = this.props,
        useGap = _this$props.useGap,
        message = _this$props.message,
        options = _this$props.options;
    var value = unescapeOptions ? (0, _unescapedText.default)(message, options) : _I18n.default.text(message, options);

    if (useGap === true) {
      value = " " + value + " ";
    }

    return value;
  },
  statics: {
    isI18nElement: true
  }
};
exports.I18nCommonMixin = I18nCommonMixin;

var getPassThroughProps = function getPassThroughProps(allProps) {
  var localeOverwrite = allProps.options && allProps.options.locale;
  var result = {
    'data-locale-at-render': localeOverwrite || _I18n.default.locale,
    'data-key': allProps.message
  };

  var _arr = Object.keys(allProps);

  for (var _i = 0; _i < _arr.length; _i++) {
    var propKey = _arr[_i];

    if (['message', 'options', 'useGap'].indexOf(propKey) < 0) {
      result[propKey] = allProps[propKey];
    }
  }

  return result;
};

exports.getPassThroughProps = getPassThroughProps;

var classNameFix = function classNameFix(props) {
  var className = props.className,
      classProp = props.class,
      restProps = (0, _objectWithoutProperties2.default)(props, ["className", "class"]);

  if (className && !classProp) {
    return (0, _extends2.default)({
      class: className
    }, restProps);
  }

  return props;
};

exports.classNameFix = classNameFix;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/components/utils.js
// module id = 259
// module chunks = 209 210 211 212